
import React from "react";
import { toast } from "react-toastify";
import useApi from "../useApi";

export interface TransactionData {
  _id: string;
  totalTransaction: number;
}

interface TransactionsResponse {
  status: string;
  data: TransactionData[];
}

const useTotalTransactions = () => {
  const [transactions, setTransactions] = React.useState<TransactionData[]>([]);
  const [loading, setLoading] = React.useState(false);

  const { makeApiCall } = useApi({
    url: "/rtm/dashboard/total-transaction",
    method: "GET",
  });

  const getTotalTransactions = async (fromDate?: string, toDate?: string) => {
    setLoading(true);
    try {
    
      let queryParams = [];
      if (fromDate) queryParams.push(`fromDate=${fromDate}`);
      if (toDate) queryParams.push(`toDate=${toDate}`);
      
      const baseUrl = "/rtm/dashboard/total-transaction";
      const urlWithParams = queryParams.length > 0 
        ? `${baseUrl}?${queryParams.join('&')}`
        : baseUrl;
      
      const { response, error } = await makeApiCall<undefined, TransactionsResponse>(
        undefined,
        urlWithParams
      );

      if (response?.status === "success") {
        setTransactions(response.data);
      } else if (error) {
        toast.error("Failed to fetch transaction data");
      }
    } catch (err) {
      toast.error("An error occurred while fetching transaction data");
    } finally {
      setLoading(false);
    }
  };

  return {
    transactions,
    getTotalTransactions,
    loading,
  };
};

export default useTotalTransactions;